// extracted by mini-css-extract-plugin
export default {"root":"djecxDk","bg":"s8KgwlB","message":"hTgUE7W"};